export enum LoginStep {
  Configuration = 1,
  Flow = 2,
}
